export { IColumns } from './IColumns';
export { ISportsConfiguration } from './ISportsConfiguration';
export { IOfferMapperConfiguration } from './IOfferMapperConfiguration';
export { IMainSportHeaders } from './IMainSportHeaders';
export { IMappingGroup } from './IMappingGroup';

export * from './rules';